import { Address } from "../../common/models/address.model";
import { CarRefItemStatus } from "../constants/car-basic-data";


export class CarManufacturer {
    id: number = 0;
    
    code = '';
    name = '';
    details = '';
    partsOnly: boolean = false;
    hqAddressId: number = 0;
    hqAddress: Address = new Address('', 0);
    keyLocations : Address[] = [];

    status: CarRefItemStatus = CarRefItemStatus.REVIEW;
    created = '';
    lastUpdated = '';
    lastUpdatedBy = '';
  
    constructor (code: string, name: string, partsOnly: boolean)  {
        this.code = code!;
        this.name = name!;
        this.partsOnly = partsOnly!;
    }
  }
  